import { addDays, format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt';
import api from './api';

export const selectTiltById = async (payload) => {
  const response = await api.get(`tilt/${payload}`);
  const tilt = response.data.map((t) => ({
    ...t,
    STATUS_GRAVACAO: t.STATUS_GRAVACAO ?? t.GRAVADO ?? null,
    dataTilt: format(addDays(parseISO(t.DATATILT), 1), 'dd/MM/yyyy', {
      locale: pt,
    }),
    dataNasc: format(addDays(parseISO(t.DTNPAC), 1), 'dd/MM/yyyy', {
      locale: pt,
    }),
    idadePAC: Math.floor((parseISO(t.DATATILT) - parseISO(t.DTNPAC)) / (1000 * 3600 * 24) / 365.25),
  }));
  return tilt;
};

export const updateTilt = async (id, data) => {
  const response = await api.put(`tilt/${id}`, data);
  return response.data;
};
